import Marquee from "react-fast-marquee";

const ITEMS = [
  "Seven Homesites Available",
  "Premier Levee-Side Lot",
  "Cul-de-Sac & Corner Settings",
  "Custom-Home Opportunity",
  "Established Community",
  "Platt, Sequoia & Verde Streets",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="bg-cream border-y border-border py-8 overflow-hidden">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <div key={item} className="flex items-center gap-16 mr-16">
          <span className="font-serif text-2xl sm:text-3xl text-forest/85 italic whitespace-nowrap">{item}</span>
          <span className="w-2 h-2 rotate-45 bg-brass shrink-0" />
        </div>
      ))}
    </Marquee>
  </div>
);
